var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9c-1.1 0-2.042-.392-2.825-1.175C4.392 7.042 4 6.1 4 5V1.5c0-.417.146-.77.438-1.063A1.447 1.447 0 0 1 5.5 0c.25 0 .487.058.713.175.224.117.404.283.537.5a1.35 1.35 0 0 1 .537-.5C7.513.058 7.75 0 8 0c.25 0 .488.058.713.175.225.117.404.283.537.5a1.35 1.35 0 0 1 .537-.5C10.012.058 10.25 0 10.5 0c.417 0 .77.146 1.063.438.291.291.437.645.437 1.062V5c0 1.1-.392 2.042-1.175 2.825C10.042 8.608 9.1 9 8 9Zm0-2c.55 0 1.02-.196 1.412-.588C9.804 6.021 10 5.55 10 5V2.5H6V5c0 .55.196 1.02.588 1.412C6.979 6.804 7.45 7 8 7ZM0 17v-2.8c0-.567.146-1.087.438-1.563.291-.475.679-.837 1.162-1.087a14.843 14.843 0 0 1 3.15-1.163A13.76 13.76 0 0 1 8 10c1.1 0 2.183.13 3.25.387 1.067.259 2.117.646 3.15 1.163.483.25.87.612 1.162 1.087.292.476.438.996.438 1.563V17H0Zm2-2h12v-.8a.973.973 0 0 0-.5-.85c-.9-.45-1.808-.787-2.725-1.012a11.6 11.6 0 0 0-5.55 0c-.917.225-1.825.562-2.725 1.012a.973.973 0 0 0-.5.85v.8Z",
    fill: "#2F42C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileAccount);
export default __webpack_public_path__ + "static/media/profile_account.da1b3b2f6713c0c6e3291ae3e3a37b18.svg";
export { ForwardRef as ReactComponent };